import { useEffect, useState, useCallback } from "react";
import { capitalize, debounce } from "lodash";
import { Box, Button, Card, CardContent, CardHeader, IconButton, Input, InputAdornment, Tooltip, Dialog, DialogActions, DialogTitle, Slider, Typography, Grid, Paper, Chip, FormControl, InputLabel, Select, MenuItem, Divider, Checkbox, ListItemText } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SearchIcon from "@mui/icons-material/Search";
import FilterListIcon from "@mui/icons-material/FilterList";
import ClearIcon from "@mui/icons-material/Clear";
import RefreshIcon from "@mui/icons-material/Refresh";
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import { walletServices } from "../../services/AllServices";
import errorHandler from "../../utils/errorHandler";
import TableFilter from "../../components/shared/TableFilter";
import { TRANSACTIONTYPE_TYPE, Verification_OPTIONS } from "../../utils/constants";
import { useNavigate, useParams } from "react-router-dom";
import { Loader } from "../../components/CustomLoader";
import { fDate } from "../../utils/formatTime";
import { formatPrice } from "../../utils/formatNumber";
import ViewTransactionDetail from "./ViewTransactionDetail";
import BackButton from "../../components/Buttons/BackButton";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import "dayjs/locale/en-gb";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";


export default function AllTrangectionList() {
    const navigate = useNavigate();
    const [searchItem, setSearchItem] = useState("");
    const [data, setData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [status, setStatus] = useState([]);
    const [show, setShow] = useState(false);
    const [warning, setWarning] = useState("");
    const [currentStatus, setCurrentStatus] = useState(null);
    const [statusId, setStatusId] = useState("");
    const [refresh, setRefresh] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [viewId, setViewId] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [loaderDelay, setLoaderDelay] = useState(false);
    const [type, setType] = useState([]);
    const [priceRange, setPriceRange] = useState([0, 1000]);
    const [selectedYear, setSelectedYear] = useState("");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    // Separate state for UI display and actual filter values
    const [displayPriceRange, setDisplayPriceRange] = useState([0, 1000]);
    const [filterPriceRange, setFilterPriceRange] = useState([0, 1000]);


    const years = Array.from({ length: 5 }, (_, i) => new Date().getFullYear() - i);
    const { id } = useParams();

    const fetchUsers = async (query) => {
        if (id) {

            const body = {
                searchItem: query || "",
                page: currentPage,
                pageSize: pageSize,
                transactionStatus: status,
                transactionType: type,
                priceMin: filterPriceRange[0] || undefined,
                priceMax: filterPriceRange[1] || undefined,
                userId: id,
                dateFrom: startDate || (selectedYear ? `${selectedYear}-01-01` : undefined),
                dateTo: endDate || (selectedYear ? `${selectedYear}-12-31` : undefined)
            };

            try {
                setIsLoading(true);
                setLoaderDelay(false);
                const res = await walletServices.getusertransaction(body);
                setTimeout(() => {
                    if (res.status === 200) {
                        setData(res?.data?.data?.transactions);
                        setTotalPages(res?.data?.data?.total);
                    }
                    setLoaderDelay(true);
                }, 500);
            } catch (err) {
                setData(err?.response?.data?.message?.data);
                errorHandler(err);
                setLoaderDelay(false);
            } finally {
                setIsLoading(false);
                setLoaderDelay(false);
            }
        }
    };


    const debouncedPriceFilter = useCallback(
        debounce((newPriceRange) => {
            setFilterPriceRange(newPriceRange);
        }, 1000),
        []
    );

    const debouncedSearch = useCallback(
        debounce((query) => fetchUsers(query), 400),
        [currentPage, pageSize, status, type]
    );

    const handleSearchChange = (event) => {
        const query = event.target.value;
        setSearchItem(query);
        debouncedSearch(query);
    };

    const debouncedFetchUsers = useCallback(
        debounce((value) => {
            fetchUsers(value);
        }, 1000),
        []
    );


    // Handle price range changes
    const handlePriceRangeChange = useCallback((event, newValue) => {
        // Update display immediately for responsive UI
        setDisplayPriceRange(newValue);
        // Debounce the actual filter update
        debouncedPriceFilter(newValue);
    }, [debouncedPriceFilter]);

    // const handlePriceRangeChange = useCallback((event, newValue) => {
    //     setPriceRange(newValue);

    //     if (newValue[0] > 0 || newValue[1] < 100) {
    //         debouncedFetchUsers(searchItem);
    //     }

    // }, [searchItem, debouncedFetchUsers]);


    // Effect to trigger API call when filter values change
    useEffect(() => {
        fetchUsers(searchItem);
    }, [currentPage, pageSize, status, refresh, id, type, filterPriceRange, selectedYear, startDate, endDate]);


    const handlePageChange = (page) => setCurrentPage(page);

    const handleApprove = async (id, action) => {
        const actionText = action === "completed" ? "accept this transaction" : "reject this transaction";

        Swal.fire({
            text: `Are you sure you want to ${actionText}?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#00a1da",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const payload = {
                        transactionId: id,
                        status: action,
                    };

                    const res = await walletServices.ApproveRejectAmount(payload);
                    if (res.status === 200) {
                        toast.success(res?.data?.message, { toastId: "success" });
                        setRefresh((prev) => !prev);
                    } else {
                        toast.error(res?.data?.message, { toastId: "error" });
                    }
                } catch (err) {
                    errorHandler(err);
                }
            }
        });
    };

    const toggleChecked = async (id, currentStatus) => {
        try {
            const newStatus = currentStatus === 1 ? 0 : 1;
            const res = await walletServices.changeStatus({
                id,
                status: newStatus,
            });

            if (res.status === 200) {
                toast.success(res?.data?.message, { toastId: "success" });
                setRefresh(!refresh);
            } else {
                toast.error(res?.data?.message, { toastId: "error" });
            }
        } catch (err) {
            errorHandler(err);
        }
    };

    useEffect(() => {
        // Always fetch on mount or when dependencies change
        fetchUsers(searchItem);
    }, [currentPage, pageSize, status, refresh, id, type, priceRange, selectedYear, startDate, endDate]);

    const columns = [
        {
            name: "S.No.",
            cell: (row, index) => (currentPage - 1) * pageSize + index + 1,
            width: "100px"
        },
        {
            width: "240px",
            name: "Transaction Id",
            sortable: true,
            selector: (row) => row.transactionId || "NA",
        },
        {
            width: "250px",
            name: "Payment ID (Apco ID)",
            sortable: true,
            selector: (row) => capitalize(row?.pspid || "-"),
        },

        {
            width: "150px",
            name: "Amount",
            center: true,
            sortable: true,
            selector: (row) => row.amount ? formatPrice(row.amount) : "NA",
        },
        {
            width: "200px",
            name: "Payment Methord",
            sortable: true,
            selector: (row) => capitalize(row?.paymentMethord),
        },

        {
            width: "200px",
            name: "Transaction Type",
            sortable: true,
            selector: (row) => capitalize(row.transactionType),
        },
        {
            width: "200px",
            name: "Transaction Date",
            sortable: true,
            selector: (row) => capitalize(fDate(row.createdAt)),
        },

        {
            width: "180px",
            name: "Contest Name",
            center: true,
            cell: (row) => (
              <>
              {row?.contestId?._id ? (
                <Tooltip title="View" placement="top">
                  <span
                    onClick={() => {
                        if(row?.contestId?._id){
                            navigate(`/contest-management/view/${row?.contestId?._id}`);
                        }
                    }}
                  >
                     {capitalize(row.contestId?.contestName)}
                    </span>
                </Tooltip>
              ) : (
                <span>NA</span>
              )}
              </>
            ),
          },

        {

            name: "Status",
            cell: (row) => (
                <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                    {row.status === "pending" ? (
                        <>
                            <Button
                                variant="contained"
                                size="small"
                                onClick={() => handleApprove(row._id, "completed")}
                                sx={{
                                    backgroundColor: 'success.main',
                                    '&:hover': { backgroundColor: 'success.dark' },
                                    borderRadius: 2,
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    px: 2,
                                }}
                            >
                                Accept
                            </Button>
                            <Button
                                variant="contained"
                                color="error"
                                size="small"
                                onClick={() => handleApprove(row._id, "cancelled")}
                                sx={{
                                    borderRadius: 2,
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    px: 2,
                                }}
                            >
                                Reject
                            </Button>
                        </>
                    ) : (
                        <Chip
                            label={capitalize(row.status)}
                            color={
                                row.status === "completed" ? "success" :
                                    row.status === "cancelled" ? "error" : "default"
                            }
                            variant="filled"
                            sx={{
                                fontWeight: 600,
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                            }}
                        />
                    )}
                </Box>
            ),
        },

        {
            name: "Actions",
            center: true,
            cell: (row) => (
                <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
                    <Tooltip title="View Details" placement="top">
                        <IconButton
                            color="primary"
                            onClick={() => {
                                setModalShow(true);
                                setViewId(row._id);
                            }}
                            sx={{
                                backgroundColor: 'primary.light',
                                color: 'white',
                                '&:hover': {
                                    backgroundColor: 'primary.main',
                                    transform: 'scale(1.1)',
                                },
                                transition: 'all 0.2s ease-in-out',
                            }}
                        >
                            <VisibilityIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Box>
            ),
        },
    ];

    return (

        <Card sx={{ borderRadius: 2, boxShadow: 3, backgroundColor: 'background.paper', mx: 2, my: 2 }}>
            <CardHeader
                title={
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, py: 1 }}>
                        <BackButton variant="h6" />
                        <Typography variant="h5" sx={{ fontWeight: 600, color: 'primary.main' }}>
                            Transaction History
                        </Typography>
                    </Box>
                }
                sx={{ pb: 1 }}
            />

            {/* Enhanced Filter Section */}
            <Paper elevation={1} sx={{
                p: 4,
                mx: 3,
                mb: 3,
                borderRadius: 2,
                backgroundColor: 'background.paper',
                border: '1px solid',
                borderColor: 'divider'
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <FilterListIcon sx={{ mr: 1.5, color: 'primary.main' }} />
                    <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary' }}>
                        Filters & Search
                    </Typography>
                </Box>

                <Grid container spacing={4} alignItems="center">
                    {/* Search Input */}
                    <Grid item xs={12} md={3}>
                        <Input
                            value={searchItem}
                            placeholder="Search transactions..."
                            onChange={handleSearchChange}
                            startAdornment={
                                <InputAdornment position="start">
                                    <SearchIcon color="action" />
                                </InputAdornment>
                            }
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="clear-search"
                                        onClick={() => {
                                            setSearchItem("");
                                            fetchUsers("");
                                        }}
                                        size="small"
                                    >
                                        <ClearIcon />
                                    </IconButton>
                                </InputAdornment>
                            }
                            sx={{
                                backgroundColor: 'background.default',
                                borderRadius: 2,
                                border: '1px solid',
                                borderColor: 'divider',
                                '& .MuiInput-input': {
                                    padding: '12px 14px',
                                    color: 'text.primary'
                                },
                                '&:hover': {
                                    borderColor: 'primary.main'
                                },
                                '&.Mui-focused': {
                                    borderColor: 'primary.main',
                                    boxShadow: '0 0 0 2px rgba(25, 118, 210, 0.2)'
                                }
                            }}
                        />
                    </Grid>

                    {/* Status Filter */}
                    <Grid item xs={12} md={2}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="status-label" sx={{
                                color: 'text.primary',
                                '&.Mui-focused': {
                                    color: 'primary.main'
                                }
                            }}>Status</InputLabel>
                            <Select
                                labelId="status-label"
                                multiple
                                value={status}
                                onChange={(e) => setStatus(e.target.value)}
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {selected.map((value, index) => (
                                            <Chip
                                                key={`status-${value}-${index}`}
                                                label={value}
                                                size="small"
                                                sx={{
                                                    backgroundColor: 'primary.main',
                                                    color: 'white',
                                                    '& .MuiChip-deleteIcon': {
                                                        color: 'white'
                                                    }
                                                }}
                                            />
                                        ))}
                                    </Box>
                                )}
                                sx={{
                                    backgroundColor: 'background.default',
                                    color: 'text.primary',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'divider'
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'primary.main'
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'primary.main'
                                    }
                                }}
                            >
                                {Verification_OPTIONS.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        <Checkbox checked={status.indexOf(option.value) > -1} />
                                        <ListItemText primary={option.label} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    {/* Transaction Type Filter */}
                    <Grid item xs={12} md={2}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="type-label" sx={{
                                color: 'text.primary',
                                '&.Mui-focused': {
                                    color: 'primary.main'
                                }
                            }}>Transaction Type</InputLabel>
                            <Select
                                labelId="type-label"
                                multiple
                                value={type}
                                onChange={(e) => setType(e.target.value)}
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                                        {selected.map((value, index) => (
                                            <Chip
                                                key={`type-${value}-${index}`}
                                                label={value}
                                                size="small"
                                                sx={{
                                                    backgroundColor: 'secondary.main',
                                                    color: 'white',
                                                    '& .MuiChip-deleteIcon': {
                                                        color: 'white'
                                                    }
                                                }}
                                            />
                                        ))}
                                    </Box>
                                )}
                                sx={{
                                    backgroundColor: 'background.default',
                                    color: 'text.primary',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'divider'
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'primary.main'
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'primary.main'
                                    }
                                }}
                            >
                                {TRANSACTIONTYPE_TYPE.map((option) => (
                                    <MenuItem key={option.value} value={option.value}>
                                        <Checkbox checked={type.indexOf(option.value) > -1} />
                                        <ListItemText primary={option.label} />
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    {/* Year Filter */}
                    <Grid item xs={12} md={1.5}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="year-label" sx={{
                                color: 'text.primary',
                                '&.Mui-focused': {
                                    color: 'primary.main'
                                }
                            }}>Year</InputLabel>
                            <Select
                                labelId="year-label"
                                value={selectedYear}
                                onChange={(e) => setSelectedYear(e.target.value)}
                                sx={{
                                    backgroundColor: 'background.default',
                                    color: 'text.primary',
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'divider'
                                    },
                                    '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'primary.main'
                                    },
                                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: 'primary.main'
                                    }
                                }}
                            >
                                <MenuItem value="">All Years</MenuItem>
                                {years.map((year) => (
                                    <MenuItem key={year} value={year}>
                                        {year}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    {/* Action Buttons */}
                    <Grid item xs={12} md={3.5}>
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                            <Button
                                variant="outlined"
                                startIcon={<ClearIcon />}
                                onClick={() => {
                                    setStartDate(null);
                                    setEndDate(null);
                                    setSelectedYear("");
                                    setDisplayPriceRange([0, 1000]);
                                    setFilterPriceRange([0, 1000]);
                                    setStatus([]);
                                    setType([]);
                                    setSearchItem("");
                                    debouncedPriceFilter.cancel();
                                }}
                                size="small"
                                sx={{ borderRadius: 2 }}
                            >
                                Clear All
                            </Button>
                            <Button
                                variant="contained"
                                startIcon={<RefreshIcon />}
                                onClick={() => fetchUsers(searchItem)}
                                size="small"
                                sx={{ borderRadius: 2 }}
                            >
                                Refresh
                            </Button>
                        </Box>
                    </Grid>
                </Grid>

                <Divider sx={{ my: 3 }} />

                {/* Date Range and Amount Range */}
                <Grid container spacing={4} alignItems="flex-start">
                    {/* Date Range */}
                    <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: 'text.primary' }}>
                            Date Range
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 3 }}>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker
                                    label="Start Date"
                                    value={startDate ? dayjs(startDate) : null}
                                    onChange={(newDate) => {
                                        setStartDate(newDate ? dayjs(newDate).format("YYYY-MM-DD") : null);
                                    }}
                                    format="DD/MM/YYYY"
                                    slotProps={{
                                        textField: {
                                            variant: "outlined",
                                            fullWidth: true,
                                            size: "small",
                                            sx: {
                                                backgroundColor: 'background.default',
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'divider'
                                                },
                                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'primary.main'
                                                },
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'primary.main'
                                                }
                                            }
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
                                <DatePicker
                                    label="End Date"
                                    value={endDate ? dayjs(endDate) : null}
                                    onChange={(newDate) => {
                                        setEndDate(newDate ? dayjs(newDate).format("YYYY-MM-DD") : null);
                                    }}
                                    format="DD/MM/YYYY"
                                    slotProps={{
                                        textField: {
                                            variant: "outlined",
                                            fullWidth: true,
                                            size: "small",
                                            sx: {
                                                backgroundColor: 'background.default',
                                                '& .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'divider'
                                                },
                                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'primary.main'
                                                },
                                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                                    borderColor: 'primary.main'
                                                }
                                            }
                                        },
                                    }}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Grid>

                    {/* Amount Range */}
                    <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: 'text.primary' }}>
                            Amount Range: ${formatPrice(displayPriceRange[0])} - ${formatPrice(displayPriceRange[1])}
                        </Typography>
                        <Box sx={{ px: 3, py: 1 }}>
                            <Slider
                                value={displayPriceRange}
                                onChange={handlePriceRangeChange}
                                valueLabelDisplay="auto"
                                valueLabelFormat={(value) => `$${value}`}
                                min={0}
                                max={1000}
                                step={10}
                                marks={[
                                    { value: 0, label: '$0' },
                                    { value: 250, label: '$250' },
                                    { value: 500, label: '$500' },
                                    { value: 750, label: '$750' },
                                    { value: 1000, label: '$1000' }
                                ]}
                                sx={{
                                    color: 'primary.main',
                                    '& .MuiSlider-thumb': {
                                        width: 20,
                                        height: 20,
                                        backgroundColor: 'primary.main',
                                        border: '2px solid white',
                                        boxShadow: '0 2px 4px rgba(0,0,0,0.3)',
                                        '&:hover': {
                                            boxShadow: '0 4px 8px rgba(0,0,0,0.4)',
                                        }
                                    },
                                    '& .MuiSlider-track': {
                                        height: 6,
                                        backgroundColor: 'primary.main',
                                    },
                                    '& .MuiSlider-rail': {
                                        height: 6,
                                        backgroundColor: 'divider',
                                    },
                                    '& .MuiSlider-mark': {
                                        backgroundColor: 'text.secondary',
                                    },
                                    '& .MuiSlider-markLabel': {
                                        color: 'text.primary',
                                        fontWeight: 500
                                    },
                                    '& .MuiSlider-valueLabel': {
                                        backgroundColor: 'primary.main',
                                        color: 'white',
                                        fontWeight: 600
                                    }
                                }}
                            />
                        </Box>
                    </Grid>
                </Grid>
            </Paper>
            <CardContent sx={{ p: 0, mx: 3, mb: 3 }}>
                <Paper elevation={0} sx={{ borderRadius: 2, overflow: 'hidden', backgroundColor: 'background.paper' }}>
                    <DataTable
                        customStyles={{
                            headCells: {
                                style: {
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    backgroundColor: '#1976d2',
                                    color: '#ffffff !important',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    padding: '20px 16px',
                                    borderBottom: 'none',
                                },
                            },
                            cells: {
                                style: {
                                    fontSize: "14px",
                                    padding: '16px',
                                    borderBottom: '1px solid',
                                    borderBottomColor: 'divider',
                                    color: 'text.primary',
                                },
                            },
                            rows: {
                                style: {
                                    backgroundColor: 'background.paper',
                                    '&:nth-of-type(odd)': {
                                        backgroundColor: 'action.hover',
                                    },
                                    '&:hover': {
                                        backgroundColor: 'action.selected',
                                        cursor: 'pointer',
                                    },
                                },
                            },
                            pagination: {
                                style: {
                                    backgroundColor: 'background.default',
                                    borderTop: '1px solid',
                                    borderTopColor: 'divider',
                                    padding: '20px 24px',
                                    color: 'text.primary',
                                },
                            },
                        }}
                        columns={columns}
                        data={data}
                        pagination
                        paginationServer
                        paginationTotalRows={totalPages}
                        onChangePage={handlePageChange}
                        paginationPerPage={pageSize}
                        paginationRowsPerPageOptions={[10, 20, 50, 100]}
                        onChangeRowsPerPage={(currentRowsPerPage) =>
                            setPageSize(currentRowsPerPage)
                        }
                        progressPending={isLoading || !loaderDelay}
                        progressComponent={<Loader />}
                        noDataComponent={
                            <Box sx={{ p: 6, textAlign: 'center' }}>
                                <Typography variant="h6" color="black" sx={{ mb: 2 }}>
                                    No transactions found
                                </Typography>
                                <Typography variant="body2" color="black">
                                    Try adjusting your filters or search criteria
                                </Typography>
                            </Box>
                        }
                        className="custom"
                    />
                </Paper>
            </CardContent>

            <Dialog
                open={show}
                onClose={() => setShow(false)}
                className="popupbox-statis"
            >
                <DialogTitle>{warning}</DialogTitle>
                <DialogActions className="status-box-action">
                    <Button
                        variant="outlined"
                        onClick={() => {
                            toggleChecked(statusId, currentStatus);
                            setShow(false);
                        }}
                        color="primary"
                    >
                        Yes
                    </Button>
                    <Button
                        variant="outlined"
                        onClick={() => setShow(false)}
                        color="primary"
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
            {modalShow ? (
                <ViewTransactionDetail
                    show={modalShow}
                    onHide={() => setModalShow(false)}
                    id={viewId}
                />
            ) : (
                ""
            )}
        </Card>
    );
}